import CardDzikirMemo from './CardDzikirMemo';

export default CardDzikirMemo;
